export const CREATE_SUB_JOB_RETURN = 'CREATE_SUB_JOB_RETURN';
export const GET_SUB_JOB_RETURNS = 'GET_SUB_JOB_RETURNS';
export const SUB_JOB_RETURN_REQUEST = 'SUB_JOB_RETURN_REQUEST';
export const UPDATE_SUB_JOB_RETURN = 'UPDATE_SUB_JOB_RETURN';
export const DELETE_SUB_JOB_RETURN = 'DELETE_SUB_JOB_RETURN';
export const SUB_JOB_RETURN_REQUEST_FAILURE = 'SUB_JOB_RETURN_REQUEST_FAILURE';